import { apiClient } from '@/api/client'
import {
  TAX_RULES,
  TAX_RULES_CALCULATE_PREVIEW,
  TAX_RULES_EXCHANGE_RATES,
  taxRulePath,
  taxRuleDeactivatePath,
} from '@/api/endpoints'
import type { ApiResponseWrapper } from '@/types/api.types'
import type {
  TaxRule,
  CreateTaxRuleDto,
  UpdateTaxRuleDto,
  TaxRuleListFilters,
  TaxPreviewParams,
  TaxPreviewResult,
  CreateExchangeRateDto,
  ExchangeRate,
} from '@/features/tax-rules/types/tax-rule.types'

interface PaginatedData<T> {
  data: T[]
  total: number
  page: number
  limit: number
}

export async function listTaxRules(
  params?: TaxRuleListFilters,
): Promise<PaginatedData<TaxRule>> {
  const { data } = await apiClient.get<ApiResponseWrapper<PaginatedData<TaxRule>>>(
    TAX_RULES,
    { params },
  )
  return data.data
}

export async function getTaxRule(id: string): Promise<TaxRule> {
  const { data } = await apiClient.get<ApiResponseWrapper<TaxRule>>(taxRulePath(id))
  return data.data
}

export async function createTaxRule(body: CreateTaxRuleDto): Promise<TaxRule> {
  const { data } = await apiClient.post<ApiResponseWrapper<TaxRule>>(TAX_RULES, body)
  return data.data
}

export async function updateTaxRule(id: string, body: UpdateTaxRuleDto): Promise<TaxRule> {
  const { data } = await apiClient.patch<ApiResponseWrapper<TaxRule>>(taxRulePath(id), body)
  return data.data
}

export async function deactivateTaxRule(id: string): Promise<TaxRule> {
  const { data } = await apiClient.post<ApiResponseWrapper<TaxRule>>(taxRuleDeactivatePath(id))
  return data.data
}

export async function calculatePreview(params: TaxPreviewParams): Promise<TaxPreviewResult> {
  const { data } = await apiClient.get<ApiResponseWrapper<TaxPreviewResult>>(
    TAX_RULES_CALCULATE_PREVIEW,
    { params },
  )
  return data.data
}

export async function createExchangeRate(body: CreateExchangeRateDto): Promise<ExchangeRate> {
  const { data } = await apiClient.post<ApiResponseWrapper<ExchangeRate>>(
    TAX_RULES_EXCHANGE_RATES,
    body,
  )
  return data.data
}
